<template>
    <div class="final">
        <h1 :class="{ collapsed: toggledFaq }">{{ heading }}</h1>
        <p :class="{ collapsed: toggledFaq }">Je zult nog een hoop vragen hebben.<br />Hieronder zullen we de belangrijkste voor je proberen te beantwoorden:</p>

        <div class="faqs">
            <Faq v-for="faq in faqs" :key="faq.id" :faq="faq" :toggledFaq="toggledFaq" @toggleFaq="toggleFaq"/>
        </div>
        <div class="buttons">
            <button class="app-btn" @click="$emit('back')">Terug</button>
            <button class="app-btn" @click="$emit('signUp')">Inschrijven</button>
            <!-- <button class="app-btn" @click="$emit('moreFaqs')">Andere veelgestelde vragen</button> -->
        </div>
    </div>
</template>

<script>
import Faq from '@/components/Faq.vue'
import jsonFaqs from '@/assets/data/faqs.json'

export default {
    name: 'Final',
    components: {
        Faq
    },
    props: {
        heading: String,
        answers: Array
    },
    data () {
        return {
            allFaqs: jsonFaqs,
            toggledFaq: null
        }
    },
    computed: {
        faqs () {
            return this.allFaqs[this.faqIndex].faqs
        },
        faqIndex () {
            if (this.answers[0].answer === 'child' && this.answers[2].answer === 'improve') {
                return 0
            } else if (this.answers[0].answer === 'child' && this.answers[2].answer === 'competition') {
                return 1
            } else if (this.answers[0].answer === 'teenager' && this.answers[1].answer === 'beginner' && this.answers[2].answer === 'competition') {
                return 3
            } else if (this.answers[0].answer === 'teenager' && this.answers[2].answer === 'competition') {
                return 4
            } else if (this.answers[0].answer === 'teenager' && this.answers[1].answer === 'experienced') {
                return 5
            } else if (this.answers[0].answer === 'teenager') {
                return 2
            } else if (this.answers[0].answer === 'adult' && this.answers[1].answer === 'beginner' && this.answers[2].answer === 'improve') {
                return 6
            } else if (this.answers[0].answer === 'adult' && this.answers[1].answer === 'beginner' && this.answers[2].answer === 'tours') {
                return 7
            } else if (this.answers[0].answer === 'adult' && this.answers[1].answer === 'beginner' && this.answers[2].answer === 'competition') {
                return 9
            } else if (this.answers[0].answer === 'adult' && this.answers[2].answer === 'competition') {
                return 10
            }
            return 8
        }
    },
    methods: {
        toggleFaq (id) {
            if (this.toggledFaq !== id) {
                this.toggledFaq = id
            } else {
                this.toggledFaq = null
            }
        },

    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/main.scss';

    .final {
        text-align: left;
    }

    h1 {
        transition: all 0.25s;

        &.collapsed {
            max-height: 0;
            margin: 0;
            overflow: hidden;
            @include transition-in();
        }

        @include bp-lg {
            margin: 0 0 1.5rem;
            font-size: 3rem;
        }
    }

    p {
        max-height: 10rem;
        overflow: hidden;

        &.collapsed {
            max-height: 0;
            margin: 0;
            @include transition-in();
        }
    }

    .faqs {
        margin: 0 0 4rem 0;
        border: 2px solid white;
        border-radius: 8px;
    }

    .buttons {
        text-align: center;
    }

</style>
